<template>
  <login-form />
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import LoginForm from '../common/components/auth/LoginForm.vue'

export default {
  name: 'Login',
  mixins: [mainMixin],

  components: {
    LoginForm
  },

  created () {
    this.hidePreloader()
  }
}
</script>
